import { render, staticRenderFns } from "./RecommendItem.vue?vue&type=template&id=5a2f66fe&scoped=true"
import script from "./RecommendItem.vue?vue&type=script&lang=js"
export * from "./RecommendItem.vue?vue&type=script&lang=js"
import style0 from "./RecommendItem.vue?vue&type=style&index=0&id=5a2f66fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f66fe",
  null
  
)

export default component.exports